(() => {
    'use strict';

    howspace.widgets.leaderboard = {
        initView: widget => {
            // Empty for now.
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            if (dataPayload.metrics_type === 'progress') {
                dataPayload.metrics = ['progress'];
            }
            delete dataPayload.metrics_type;

            if (dataPayload.time_period !== 'custom') {
                dataPayload.time_period_begin_date = null;
                dataPayload.time_period_end_date = null;
            }

            return dataPayload;
        },
        updateFilter : (widget) => {
            const lister = widget.find('.howspace-lister');

            howspace.components.lister.reload(lister);
        },
    };
})();
